export enum BehaviorCodeEntryConfirmReactionListColumnsEnum {
  STUDENT_NAME = 'Student Name',
  REACTION = 'Reaction',
  REACTION_DATE = 'Reaction Date',
  ACTIONS = 'Actions'
}
